import React from 'react';
import ReactDOM from 'react-dom';
import IndexPage from './pages/IndexPage';
import PwResetPage from './pages/PwResetPage';
import ConfirmMailPage from './pages/ConfirmMailPage';
import '../assets/css/style.css';
import './i18n/config';
var indexRoot = document.getElementById('index-root');
if (indexRoot) {
    ReactDOM.render(React.createElement(IndexPage, null), indexRoot);
}
var pwResetRoot = document.getElementById('pw-reset-root');
if (pwResetRoot) {
    ReactDOM.render(React.createElement(PwResetPage, null), pwResetRoot);
}
var confirmMailRoot = document.getElementById('confirm-mail-root');
if (confirmMailRoot) {
    ReactDOM.render(React.createElement(ConfirmMailPage, null), confirmMailRoot);
}
